<template>
    <div class="dialog-inner" style="padding-top:0;">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" :show-message="true" class="form-col2">
            <div class="form-group-title" style="margin-top:5px;"><h2>角色信息</h2></div>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="名称" prop="roleName">
                        <el-input type="text" v-model="form.roleName" size="small" maxlength="20" @blur="fieldTrim(form, 'roleName')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="权限" prop="rbac">
                        <el-input 
                            type="text" 
                            v-model="filterText" 
                            placeholder="搜索"
                            size="small">
                        </el-input>
                        <div class="selet-tree-panel">
                            <el-tree
                                ref="tree"
                                :data="rbacTree"
                                :props="treeProps"
                                show-checkbox
                                node-key="id"
                                @check="handleCheck"
                                @check-change="handleCheckChange"
                                :filter-node-method="filterNode">
                            </el-tree>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="submit-row">
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" :loading="submitting" size="small">提交</el-button>
                        <el-button @click="resetForm" size="small">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import http from "@/utils/http"
import common from "@/utils/common"
import verify from "@/utils/verify"

export default {
    name: 'RoleAdd',
    data(){
        return {
            rbacTree: [],
            treeProps: {
                children: 'children',
                label: 'name'
            },
            filterText: '',
            form: {
                roleName: '',
                rbac: '',
            },
            rules: {
                name: [{required: true, message: '名称不能为空', trigger: 'blur'}],
            },
            rbac: [],
            submitting: false
        }
    },
    created() {
        this.$nextTick(() => {
            this.loadRbacList();
        });
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        rbac(val) {
            if (val.length == 0) {
                this.form.rbac = '';
                return;
            }
            this.form.rbac = ',' + val.join(',') + ',';
        }
    },
    methods: {
        ...common,
        ...verify,
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        loadRbacList() {
            let loading = this.load();
            http.get('v1/role/rolePermissionTree').then(req => {
                loading.close();
                if (req.data.code == http.SUCCESS) {
                    this.rbacTree = req.data.data;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                loading.close();
                this.httpCatch(err);
            });
        },
        handleSubmit(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    http.post('v1/role/add', this.form).then(req => {
                        this.submitting = false;
                        if (req.data.code == http.SUCCESS) {
                            this.showSuccess('添加成功', () => {
                                this.$emit('done');
                            });
                        } else {
                            this.showError(req.data.msg);
                        }
                    }).catch(err => {
                        this.submitting = false;
                        this.httpCatch(err);
                    });
                } else {
                    return false;
                }
            });
        },
        handleCheck(data) {
            if (data.level == 2) {
                this.$refs.tree.setChecked(data.pid, true);
            }
        },
        handleCheckChange() {
            let nodes = this.$refs.tree.getCheckedNodes(false, true);
            let arr = [];
            for (let i = 0; i < nodes.length; i++) {
                arr.push(nodes[i].id);
            }
            this.rbac = arr;
        }
    }
};
</script>

<style scoped>
</style>